import {useEffect} from 'react';
import {UseFormReturn} from 'react-hook-form';
import {toast} from 'react-toastify';

import IApiViolation from 'shared/api/model/IApiViolation';
import {HEADERS_ROOT_ERROR, splitHeadersViolations} from 'features/http/lib/requestHeaders';
import CreateHttpMonitorType from 'features/http/model/HttpMonitor/CreateHttpMonitorType';

interface ISubmitErrorLike {
    message?: unknown,
    violations?: IApiViolation[],
}

export const useHeadersServerError = (form: UseFormReturn<CreateHttpMonitorType>) => {
    const {watch, setError, clearErrors, getFieldState} = form;

    useEffect(() => {
        const subscription = watch((_, {name}) => {
            const isHeadersChange = name === 'headers' || !!name?.startsWith('headers.');
            if (isHeadersChange && getFieldState(HEADERS_ROOT_ERROR).error) {
                clearErrors(HEADERS_ROOT_ERROR);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, clearErrors, getFieldState]);

    return (error: unknown) => {
        const {message, violations} = (error ?? {}) as ISubmitErrorLike;
        const {headersMessage, others} = splitHeadersViolations(violations);

        if (headersMessage) {
            setError(HEADERS_ROOT_ERROR, {type: 'server', message: headersMessage});
        }

        const toastMessage = others.length > 0 ?
            others.map((violation) => violation.message).join('\n') :
            (!headersMessage && typeof message === 'string' ? message : '');
        if (toastMessage) {
            toast.warning(toastMessage);
        }
    };
};

export default useHeadersServerError;
